<template lang="pug">
v-container.pt-8.px-8(fluid)
  //- Top title
  v-row.mb-2(no-gutters align="center")
    v-col.shrink
      v-btn.ml-n3(text icon @click="goBack" height)
        v-icon(color="neutral700" :size="24") mdi-arrow-left
    v-col.ml-3
      .text-2xl.font-semibold.neutral700--text Panel Invoice
  //- Tab header
  v-row.mt-2(no-gutters)
    v-col(cols="12" md="8")
      v-tabs(v-model="reportTab" color="basic700" :height="44" :grow="isMobileScreen")
        template(v-for="tab in tabs")
          v-tab.text-sm.font-semibold.text-none.px-4.capitalize {{ tab.text }}
    v-col(cols="12" md="4" align="end")
      .d-flex.align-center
        v-spacer
        v-btn(@click="clickSearch" icon color="neutral500")
          v-icon(size="20") $yzi-search-sm
        v-text-field(v-if="showSearchField" v-model="searchText" @blur="blurSearch" @input="queryChanged" solo dense flat placeholder="Type to search..." hide-details clearable autofocus)
        customize-column-menu.column-menu(v-if="selectedTabId === 'all'" type="all_panel_invoice_report" :showTooltip="false" iconSize="21")
        v-btn.button-sm.ml-4.white--text(color="neutral700" depressed :loading="isDownloading" :disabled="!canDownloadReport" @click="onDownloadReport") Download
        //- v-menu(offset-y left rounded="lg")
        //-   template(v-slot:activator="{ on }")
        //-     v-btn.button-sm.ml-4.white--text(v-on="on" color="neutral700" depressed :loading="isDownloading" :disabled="!canDownloadReport") Download
        //-   v-list(dense)
        //-     v-list-item-group(v-model="selectedDownloadType")
        //-       v-list-item(v-for="downloadType in downloadTypes" :key="downloadType" :value="downloadType" @click="onDownloadReport")
        //-         v-list-item-content
        //-           v-list-item-title.text-sm.neutral700--text {{ downloadType }}
  v-divider
  //- Filter
  panel-report-all-filter-row.my-4(:filters.sync="filters.all" ref="filter")
  //- Listing
  .data-table.pb-4(v-if="hasAllRequiredFilters" :class="[{ 'data-available': panels.length > 0, 'data-is-ready': !isFetching }]")
    v-data-table(:headers="headers" :items="panels" :items-per-page="pageSize + 1" hide-default-footer :loading="isFetching" disable-sort @click:row="" loader-height="4")
      template(v-slot:item.paymentMethod="{ item }")
        div(v-if="item.paymentMethod && item.paymentMethod.length > 0")
          v-row.my-1(v-for="(payment, paymentIdx) in item.paymentMethod" :key="`${payment.payment_method}-${paymentIdx}`" no-gutters)
            v-col(cols="9")
              div {{ payment.payment_method }}
            v-col(cols="3")
              div.text-right {{ payment.total | displayPriceRaw }}
  //- No filters
  v-card.rounded-lg.border-dashed.pa-8.d-flex.flex-column.justify-center.align-center.no-filter-height(v-else outlined)
    v-sheet.round-full.pa-2.neutral300.d-flex.justify-center.align-center
      v-icon(size="22" color="neutral700") $yzi-file-search-02
    .text-md.mt-4.font-semibold Apply {{ requiredItemText }} filter to display data
    .text-md.neutral500--text Apply filters located at upper left corner of the table
  v-footer.white.footer(v-if="hasAllRequiredFilters && totalCount > pageSize" app padless fixed)
    .d-flex.flex-column.grow.mb-2
      v-divider
      .d-flex.justify-end.mt-2.mx-4
        yc-pagination-custom(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" attach menu-top @input="pageChanged")
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { debounce } from '@/utils'
import CustomizeColumnMenu from '@/components/connect/CustomizeColumnMenu.vue'
import PanelReportAllFilterRow from '@/components/clinic/reports/filters/PanelReportAllFilterRow.vue'

export default {
  components: {
    CustomizeColumnMenu, PanelReportAllFilterRow
  },
  data() {
    return {
      reportTab: 0,
      searchText: null,
      showSearchField: false,
      filters: {
        all: [],
      },
      isFetching: false,
      totalCount: 0,
      pageSize: 20,
      currentPage: 1,
      panels: [],
      isDownloading: false,
      tabs: [
        {
          id: 'all',
          text: 'All'
        },
      ],
      selectedDownloadType: null,
      downloadTypes: ['pdf', 'csv']
    }
  },
  watch: {
    filters: {
      handler() {
        if (this.hasAllRequiredFilters) {
          this.currentPage = 1
          this.fetchPanels()
        }
      },
      deep: true
    },
    reportTab () {
      this.panels = []
    }
  },
  computed: {
    ...mapState('user', ['user']),
    ...mapGetters({
      company: 'getCompany',
      allPanelReportFields: 'clinic/getAllPanelInvoiceReportFields',
    }),
    isMobileScreen () {
      return this.$vuetify.breakpoint.xs
    },
    headers () {
      const runningNumber = {
        id: 'runningNumber',
        field_name: '#',
        enable: true,
        type: 'system'
      }
      let fields
      // All fields
      if (this.selectedTabId === 'all') {
        fields = [runningNumber, ...this.allPanelReportFields].filter(item => item.enable)
      }
      fields.map(item => {
        item.text = item.field_name
        item.value = item.id
        item.align = 'start'
        if (item.field_name === 'datetime') item.width = 200
        if (item.id === 'amount') item.align = 'end'
      })

      return [...fields]
    },
    params () {
      let params = {
        page: this.currentPage,
        page_size: this.pageSize,
        company: this.company.id,
        search: this.searchText || null,
        form_type: 'registration'
      }
      if (this.selectedTabId === 'all') {
        this.filters.all.forEach(filter => {
          params[filter.key] = filter.value
        })
      }
      // Date range filter
      if (params.date__gte && params.date__lte) {
        params.visit_date_range = `${params.date__gte},${params.date__lte}`
        delete params.date__gte
        delete params.date__lte
      }
      // Time range filter
      if (params.time_range) {
        params.visit_time_range = params.time_range
        delete params.time_range
      }
      // Payment ref ids filter
      if (params.payment_ref_ids) {
        params.ref_ids = params.payment_ref_ids
        delete params.payment_ref_ids
      }

      return params
    },
    hasAllRequiredFilters () {
      let requiredFilters
      let filterKeys
      // All tab
      if (this.selectedTabId === 'all') {
        requiredFilters = ['date__gte', 'date__lte', 'time_range', 'payment_ref_ids']
        filterKeys = this.filters.all.map(filter => filter.key)
      }

      return requiredFilters.every(required => filterKeys.includes(required))
    },
    canDownloadReport () {
      return this.hasAllRequiredFilters && this.panels.length > 0
    },
    selectedTabId () {
      return this.tabs[this.reportTab].id
    },
    requiredItemText () {
      if (this.selectedTabId === 'all') return 'date, time and panel'

      return 'date'
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    goBack () {
      return this.$router.push('/admin/clinic/settings')
    },
    clickSearch () {
      if (this.showSearchField) {
        if (!this.searchText || this.searchText.length === 0) {
          this.showSearchField = false
        }
      } else {
        this.showSearchField = true 
      }
    },
    blurSearch () {
      if (!this.searchText || this.searchText.length === 0) {
        this.showSearchField = false
      }
    },
    queryChanged : debounce(function () {
      this.fetchPanels()
    }, 750),
    async fetchPanels () {
      try {
        this.isFetching = true
        let url
        if (this.selectedTabId === 'all') url = '/transactions/panel_invoice'
        const { data } = await this.$axios.get(url, { params: this.params })
        if (data.results && data.count > 0) {
          this.panels = data.results.map((result, index) => this.sanitizeData(result, index))
          this.totalCount = data.count
          this.panels.push(this.sanitizedTotal(data.meta))
        } else {
          this.panels = []
          this.totalCount = 0
        }
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
      } finally {
        this.isFetching = false
      }
    },
    sanitizePrice (price) {
      if (price === null || price === undefined) return '-'

      if (price === 0) return '0'

      return this.$options.filters.displayPriceRaw(price)
    },
    calculateRunningNumber (index) {
      const offset = (this.currentPage - 1) * this.pageSize
      return offset + index + 1
    },
    sanitizeData (obj, index) {
      let newObj = {...obj}
      // All tab
      // Running number
      newObj.runningNumber = this.calculateRunningNumber(index)
      // Date time
      newObj.datetime = this.$options.filters.convertServerDate2(obj.datetime)
      // Price
      newObj.amount = this.sanitizePrice(obj.amount)
      // Diagnosis
      newObj.diagnosis = obj.diagnosis ? obj.diagnosis.join(', ') : null

      return newObj
    },
    sanitizedTotal (meta) {
      if (this.selectedTabId === 'all') {
        return {
          amount: this.sanitizePrice(meta.total_amount),
        }
      }
    },
    pageChanged () {
      this.fetchPanels()
    },
    async onDownloadReport () {
      this.isDownloading = true
      // Get key first
      let key
      try {
        const { data } = await this.$axios.post(`users/${this.user.id}/request_otk`)
        key = data.key
      } catch (error) {
        this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        this.isDownloading = false
        return
      }
      // Open download url
      let baseUrl
      if (process.env.VUE_APP_ENV === 'prod') {
        baseUrl = 'https://export.yezza.io'
      } else {
        baseUrl = 'https://export-test.yezza.io'
      }
      // Url setup
      let url
      if (this.selectedTabId === 'all') url = `${baseUrl}/transactions/panel_invoice`

      url = new URL(url)
      // Set key
      url.searchParams.set('key', key)
      // Prepare data
      const omitKey = ['page', 'page_size', 'search', 'raw']
      for (const objKey in this.params) {
        if (!omitKey.includes(objKey) && this.params[objKey]) {
          url.searchParams.set(objKey, this.params[objKey])
        }
      }
      // Download
      url.searchParams.set('export', 'pdf')
      window.open(url, '_blank')
      this.isDownloading = false
    },
  },
}
</script>

<style scoped>
.no-filter-height {
  height: 40dvh;
}

::v-deep .data-table.data-is-ready table tbody tr td:nth-child(2),
::v-deep .data-table.data-is-ready table thead tr th:nth-child(2) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 10;
  background: white;
}

::v-deep table tbody tr:nth-last-child(2) td {
  border-bottom: 1px solid transparent !important;
}

::v-deep .data-table.data-available table tbody tr:last-child td {
  border-top: 1px solid black;
}

.footer,
.column-menu {
  z-index: 11;
}

::v-deep .data-table.data-top table tbody tr td {
  vertical-align: top !important;
}
</style>